import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  UPDATE_USER_SUCCESS,
  UPDATE_AVATAR_SUCCESS,
  UPDATE_AVATAR_ERROR,
  UPDATE_USER_ERROR,
  RESET_STORE,
} from './types';
import { setToken, getToken, deleteToken } from '../tokenStore';
// eslint-disable-next-line import/no-cycle
import { fetchWithAccessToken } from './helperAction';
import { baseUrl } from '../constants/baseUrl';
import { profileAvatarToObject, profileAvatarToString } from '../helpers/profileAvatar';

export const logInUser = ({ username, password }) => async (dispatch) => {
  try {
    await dispatch({ type: RESET_STORE });

    const response = await fetch(`${baseUrl}auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ nickname: username, password }),
    });

    let user = {};
    let body = {};
    let token = {};

    switch (response.status) {
      case 200:
      case 201:
        body = await response.json();
        user.user = body.user;
        token = {
          accessToken: body.access_token,
          expiresIn: body.expires_in,
          now: new Date(),
        };
        user.token = token;

        await setToken(body.refresh_token);
        await dispatch({
          type: LOGIN_SUCCESS,
          payload: user,
        });
        break;
      default:
        await dispatch({
          type: LOGIN_ERROR,
        });
        user = {};
    }
    return user;
  } catch (e) {
    dispatch({
      type: LOGIN_ERROR,
    });
    return {};
  }
};

export const logOutUser = () => async (dispatch) => {
  try {
    const refreshToken = await getToken();

    await fetch(`${baseUrl}auth/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });

    await deleteToken();

    await dispatch({ type: LOGOUT_SUCCESS });

    return null;
  } catch (e) {
    await deleteToken();
    dispatch({
      type: LOGOUT_ERROR,
    });
    return {};
  }
};

export const registerUser = ({ username, mail, firstName, lastName, password }) => async (
  dispatch,
) => {
  try {
    const user = {
      avatar: 'default',
      nickname: username,
      firstname: firstName,
      lastname: lastName,
      email: mail,
      password,
    };
    const response = await fetch(`${baseUrl}auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    });
    const body = await response.json();

    switch (response.status) {
      case 201:
        return { error: '' };
      default:
        return { error: body.turtletException };
    }
  } catch (e) {
    dispatch({ type: LOGIN_ERROR, payload: e });
    return { error: 'Something went wrong' };
  }
};

export const updateUser = ({ id, username, mail, firstName, lastName, password }) => async (
  dispatch,
) => {
  try {
    const body = {
      avatar: 'default',
      nickname: username,
      firstname: firstName,
      lastname: lastName,
      email: mail,
      password,
    };

    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}user/data/${id}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    );

    const responseBody = await response.json();

    switch (response.status) {
      case 200:
      case 201:
        dispatch({
          type: UPDATE_USER_SUCCESS,
          payload: responseBody,
        });
        return { error: '' };
      default:
        return { error: responseBody.turtletException.message };
    }
  } catch (e) {
    dispatch({ type: UPDATE_USER_ERROR });
    return { error: 'Something went wrong' };
  }
};

export const updateAvatar = (id, avatarChange) => async (dispatch, getState) => {
  const {
    currentUser: {
      user: { avatar },
    },
  } = getState();
  const newAvatar = profileAvatarToString({ ...profileAvatarToObject(avatar), ...avatarChange });

  try {
    const body = {
      id,
      avatar: newAvatar,
    };

    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}user/avatar/${id}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    );

    const responseBody = await response.json();

    switch (response.status) {
      case 200:
      case 201:
        dispatch({
          type: UPDATE_AVATAR_SUCCESS,
          payload: responseBody,
        });
        return { error: '' };
      default:
        dispatch({
          type: UPDATE_AVATAR_ERROR,
        });
        return { error: responseBody.turtletException.message };
    }
  } catch (e) {
    dispatch({ type: UPDATE_AVATAR_ERROR, payload: new Error() });
    return { error: 'Changing the user avatar went wrong' };
  }
};

// eslint-disable-next-line consistent-return
export const fetchStatistic = ({ url, typeSuccess, typeError }) => async (dispatch) => {
  try {
    const response = await dispatch(
      fetchWithAccessToken({
        url,
        method: 'GET',
      }),
    );

    const jsonResponse = await response.json();

    switch (response.status) {
      case 200:
      case 201:
        dispatch({
          type: typeSuccess,
          payload: jsonResponse,
        });
        break;
      default:
        dispatch({
          type: typeError,
        });
    }
  } catch (e) {
    dispatch({ type: typeError, payload: e });
    return { error: `Fetching the statistic ${typeSuccess} went wrong` };
  }
};
